
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@material-ui/core';
import { Box } from '@mui/material';

interface ProductHistoryDialogProps {
  open: boolean;
  onClose: () => void;
  historyData: any[]; // Adjust the type based on your actual history data structure
}

const ProductHistoryDialog: React.FC<ProductHistoryDialogProps> = ({
  open,
  onClose,
  historyData,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    PaperProps={{ style: { height: '600px', overflow: 'hidden' } }}>
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        p: 2,
      }}>
      <Typography variant="h4" sx={{ display: 'inline-block' }}>
        Product History
      </Typography>
    </Box>
    <DialogContent>

      {historyData && historyData.length > 0 ? (
        historyData.map((historyItem) => (
          <Box
            key={historyItem._id}   
            sx={{ mb: 2, borderBottom: '1px solid #ccc', pb: 1 }}>
            <Typography variant="body1">
              <span style={{ fontWeight: 'bold' }}>
                {new Date(historyItem.createdAt).toLocaleDateString()}{' '}
              </span>
              <span style={{ marginLeft: '8px', fontWeight: 'bold' }}>
                {historyItem.description}
              </span>{' '}
              by{' '}
              <span style={{ fontWeight: 'bold' }}>
                {historyItem.createdBy.name || 'Unknown'}
              </span>
              {historyItem.changeFrom || historyItem.changeTo ? (
                <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                  {historyItem.changeFrom && (
                    <Typography
                      variant="body2"
                      sx={{ color: 'gray', marginRight: 1 }}>
                      {historyItem.changeFrom}
                    </Typography>
                  )}
                  {historyItem.changeFrom && historyItem.changeTo && (
                    <Typography
                      variant="body2"
                      sx={{ color: 'gray', margin: '0 8px' }}>
                      ➔ {/* Arrow pointing to Changed To */}
                    </Typography>
                  )}
                  {historyItem.changeTo && (
                    <Typography variant="body2" sx={{ color: 'gray' }}>
                      {historyItem.changeTo}
                    </Typography>
                  )}
                </Box>
              ) : null}
            </Typography>

            <Typography variant="body2" sx={{ color: 'gray' }}>
              {new Date(historyItem.createdAt).toLocaleTimeString()}{' '}
              {/* Display time */}
            </Typography>
          </Box>
        ))
      ) : (
        <Typography variant="body1">
          No history available for this product.
        </Typography>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary" variant="outlined">
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

export default ProductHistoryDialog;
